import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import PropTypes from 'prop-types'


const Home = () => {


	return (
		<AnimatedSpan className='page-container'>

			Hoşgeldiniz

		</AnimatedSpan>
	)
}
Home.proptypes = {
	todos: PropTypes.array,
}
export default Home
